__turbopack_context__.v({
  "details": "lzwX7G_details",
  "fieldset": "lzwX7G_fieldset",
  "filterCard": "lzwX7G_filterCard",
  "filterItems": "lzwX7G_filterItems",
  "flatDetails": "lzwX7G_flatDetails",
  "flatFilterCard": "lzwX7G_flatFilterCard",
  "flatFilterItems": "lzwX7G_flatFilterItems",
  "flatToggleFilter": "lzwX7G_flatToggleFilter",
  "toggleFilter": "lzwX7G_toggleFilter",
});
